<template>
  <div class="content">
    <div class="wrapper-features">
      <p class="features">NAJWAŻNIEJSZE CECHY <strong>VOCALE Travel Case</strong></p>
      <div class="main-features">
        <img src="@/assets/images/EtuiTravelCase/image002.png" alt="">
        <img src="@/assets/images/EtuiTravelCase/image004.png" alt="">
        <img src="@/assets/images/EtuiTravelCase/image006.png" alt="">
        <img src="@/assets/images/EtuiTravelCase/image008.png" alt="">
        <img src="@/assets/images/EtuiTravelCase/image010.png" alt="">
      </div>
    </div>
    <div class="section-1">
      <img src="@/assets/images/EtuiTravelCase/image012.png" alt="">
      <div class="description">
        <h1 class="font-size-big title">VOCALE Travel Case</h1>
        <img src="@/assets/images/EtuiTravelCase/image013.png" alt="">
      </div>
    </div>

    <div class="section-2">
      <h1 class="font-size-big title">Tekstura Premium</h1>
      <p class="font-size-middle">Materiały użyte do wykonania <strong>VOCALE Travel Case</strong> są najwyższej 
        jakości dzięki czemu są miękkie w dotyku a jednocześnie wytrzymałe i odporne na odciski 
        palców oraz otarcia.</p>
      <img src="@/assets/images/EtuiTravelCase/image015.png" alt="">
    </div>

    <div class="section-3">
      <h1 class="font-size-big title">Chroń swój tablet, chroń środowisko</h1>
      <p class="font-size-middle"><strong>VOCALE Travel Case</strong> został tak zaprojektowany aby był przyjazny 
      dla środowiska a jednocześnie aby chronił Twój tablet przed uszkodzeniami oraz był zawsze towarzyszem 
      Twojej podróży.</p>
      <img src="@/assets/images/EtuiTravelCase/image017.png" alt="">
    </div>

    <div class="section-4">
      <h1 class="font-size-big title">Idealny design</h1>
      <p class="font-size-middle">Wewnętrzna kieszeń <strong>VOCALE Travel Case</strong> idealnie zmieści 
      przewód do ładowarki. Przyjemne wnętrze spowoduje że już nigdy nie będziesz chciał się rozstawać 
      ze swoim urządzeniem.</p>
      <img src="@/assets/images/EtuiTravelCase/image019.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'EtuiTravelCase',
}
</script>

<style lang='scss' scoped>
@import '@/assets/scss/_variables.scss';



.content {
  .title {
    color: $primary;
    font-weight: normal;
  }

  .description {
    font-size: 24px;
  }

  .wrapper-features {
    margin: 60px auto 90px;
    width: fit-content;

    .features {
      font-weight: normal;
      margin-bottom: 40px;
      & > strong {
        color: $primary
      }
    }
    .main-features {
      & > img {
        max-width: 100px;
        min-width: 40px;
        margin-right: 20px;
      }

      & > img:first-child {
        margin-left: 20px;
      }

      & > img:last-child {
        margin-right: 0;
      }
    }
  }

  .section-1 {
    display: flex;
    margin-left: 50px;
    & > img {
      max-width: 700px;
    }

    .description {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 80px;
      padding-left: 50px;
      .title {
        margin: 0.67em;
        margin-bottom: 1em;
      }

      & > img {
        max-width: 155px;
      }
    }
  }

  .section-2 {
    margin-top: 200px;

    & > p {
      width: 920px;
      margin: 0 auto 20px;
      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 669px;
    }
  }

  .section-3 {
    margin-top: 170px;

    & > p {
      width: 927px;
      margin: 0 auto 60px;

      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 573px;
    }
  }

  .section-4 {
    margin-top: 150px;
    margin-bottom: 140px;
    & > p {
      width: 912px;
      margin: 0 auto 50px;
      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 800px;
    }
  }
}

@media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {

  .content {
    .wrapper-features {
      margin: 20px auto 20px;
      width: fit-content;

      .features {
        font-weight: normal;
        text-align: center;
        margin-bottom: 30px;
        & > strong {
          color: $primary
        }
      }
      .main-features {
        display: block;
        text-align: center;
        & > img {
          width: 16%;
          min-width: 40px;
          margin-right: 10px;
        }

        & > img:first-child {
          margin-left: 0;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }

    .section-1 {
      flex-direction: column;
      margin-left: 0;
      align-items: center;

      & > img {
        width: 280px;
      }
      .description {
        margin-top: 15px;
        padding: 0;
        img {
          width: 123px;
          margin: 0 auto;
        }
      }
    }

    .section-4 {
      margin-bottom: 30px;
    }

    .section-2, .section-3, .section-4 {
      margin-top: 50px;
    }

    .section-1, .section-2, .section-3, .section-4 {
      p {
        width: 100%;
      }
    }

    img {
      width: 280px;
    }
  }
}

@media screen and (max-width: $phone-max-width) {

  .content {
    .wrapper-features {
      margin: 20px auto 20px;
      width: fit-content;

      .features {
        font-weight: normal;
        text-align: center;
        margin-bottom: 30px;
        & > strong {
          color: $primary
        }
      }
      .main-features {
        display: block;
        text-align: center;
        & > img {
          width: 16%;
          min-width: 40px;
          margin-right: 10px;
        }

        & > img:first-child {
          margin-left: 0;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }

    .section-1 {
      flex-direction: column;
      margin-left: 0;
      align-items: center;

      & > img {
        width: 280px;
      }
      .description {
        margin-top: 15px;
        padding: 0;
        img {
          width: 123px;
          margin: 0 auto;
        }
      }
    }

    .section-4 {
      margin-bottom: 30px;
    }

    .section-2, .section-3, .section-4 {
      margin-top: 50px;
    }

    .section-1, .section-2, .section-3, .section-4 {
      p {
        width: 100%;
      }
    }

    img {
      width: 280px;
    }
  }
}

@media screen and (min-width: 600px) and (max-width: 1024px)  {
  .content {

    .wrapper-features {
      .main-features {
        & > img {
          margin-right: 20px;
        }

        & > img:first-child {
          margin-left: 20px;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }
    
    .section-1 {
      flex-direction: row;
      justify-content: center;

      & > img {
        width: 450px;
      }
    }

    img {
      width: 400px;
    }
  }
}

</style>